<template>
  <div class="recommendDetails">
    <div class="recommendDetailsWrap">
      <div class="recommendTabs">
        <span
          class="recommendTabItem"
          :class="{ active: activeTab === item.name }"
          v-for="item in tabOptions"
          :key="item.name"
          @click="handleAnchor(item.name)"
        >
          {{ item.label }}
        </span>
        <p class="recommendTabsPS" v-if="purchaseNum">{{ purchaseNum }}位同事已投当前产品</p>
      </div>
      <div class="recommendDetailsContent">
        <div class="detailsLeft">
          <div class="detailsHeader" v-if="recommendDetails.productName">
            <div class="detailsHeaderTitle">
              <span class="label" :class="['type' + recommendDetails.productType]">
                {{ recommendDetails.productType === '1' ? '互联网转投' : '在线投保' }}
              </span>
              <span class="title" :title="recommendDetails.productName">{{ recommendDetails.productName }}</span>
            </div>
            <div class="detailsHeaderSubTitle">{{ recommendDetails.subTitle }}</div>
            <swiper class="detailsHeaderLabels" v-if="recommendDetails.label" :options="swiperOptions">
              <swiper-slide v-for="inner in recommendDetails.label.split(',')" :key="inner">
                <span @click.stop>{{ inner }}</span>
              </swiper-slide>
            </swiper>
            <p class="detailsPrice">
              <span>{{ recommendDetails.insurancePremium | toFixed }}</span> 元起
            </p>
          </div>
          <div class="detailsBody" v-if="recommendDetails.productName">
            <!-- 保障详情、投保条件、产品简介、条款资料 -->
            <component
              v-for="item in tabOptions"
              :is="item.name"
              :recommendDetails="recommendDetails"
              :key="item.name"
            />
          </div>
          <div class="detailsFooter">大童保险{{$store.state.user.user&&$store.state.user.user.tenantId=='T0001'?'销售':'经纪'}}有限公司为您提供销售服务</div>
        </div>
        <div class="detailsRight">
          <div class="detailsQrCode" v-if="(recommendDetails.productType === '2' ||
            (recommendDetails.productType === '1' && recommendDetails.offlineProductType != '0')
          ) && recommendDetails.qrCodeUrl">
            <img src="@/assets/imgs/icon-logo.png" alt="" />
             <img class="qrCode" :src="recommendDetails.qrCodeUrl" alt="" v-if="isUrl(recommendDetails.qrCodeUrl)" />
             <img class="qrCode" :src="'data:image/jpeg;base64,' +recommendDetails.qrCodeUrl" alt="" v-else/>

            <p>微信扫一扫购买</p>
          </div>
          <div class="detailsConsultant" v-if="(recommendDetails.productType === '1' && recommendDetails.offlineProductType == '0') && consultantInfo.name">
            <h4 class="detailsTitle">预约专属顾问咨询</h4>
            <div class="consultantAvatar">
              <el-popover placement="left" width="280" trigger="hover">
                <span
                  class="avatar"
                  slot="reference"
                  :style="{ backgroundImage: `url(${consultantInfo.idCardAbsolutePath})` }"
                />
                <div class="myConsultantInfo">
                  <div class="consultant">
                    <span class="name">{{ consultantInfo.name }}</span>
                    <span class="phone">
                      <img src="@/assets/imgs/icon-phone.png" alt="" />{{ consultantInfo.phoneNo }}
                    </span>
                    <span class="tip">扫码联系我的顾问<i class="el-icon-arrow-right"/></span>
                  </div>
                  <img class="qrCode" :src="consultantInfo.wechatQrCodeAbsolutePath" alt="" />
                </div>
              </el-popover>
              <span>顾问-{{ consultantInfo.name }}</span>
              <i class="el-icon-arrow-right" />
            </div>
            <div class="consultantTis">
              专属顾问将通过您的登录手机号
              <span class="fc-primary">{{ recommendDetails.phoneNo }}</span>
              联系您，请选择您方便接听的时间
            </div>
            <div class="consultantLabels">
              <span
                :class="{ active: appointPeriod === item }"
                v-for="item in appointPeriodOptions"
                :key="item"
                @click="appointPeriod = item"
              >
                {{ item }}
              </span>
            </div>
            <el-button type="primary" :disabled="!appointPeriod" @click="handleAppoint">立即预约</el-button>
          </div>
          <div class="detailsLikes" v-if="randomRecommendList.length">
            <h4 class="detailsTitle">猜你喜欢</h4>
            <div class="detailsLikesItem" v-for="item in randomRecommendList" :key="item.recommendId">
              <h4 class="detailsLikesName" @click="handleLike(item)">{{ item.productName }}</h4>
              <div class="detailsLikesLabel">
                <span v-for="inner in item.label.split(',')" :key="inner">{{ inner }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DtCopyright />
    <MyConsultant />
    <DtPopup :isShow.sync="appointShow" @close="appointShow = false" title="预约顾问咨询" width="40%" :footer="false">
      <div class="recommendDialogWrap" v-if="appointInfo.createTime">
        <p>
          您已于<span class="fc-primary">{{ appointInfo.createTime }}</span
          >预约顾问<span class="fc-primary">{{ appointInfo.agentName }}</span
          >咨询，24小时内仅能预约一次，请您耐心等待顾问联系或主动致电顾问咨询
        </p>
        <el-button type="primary" @click="appointShow = false">我知道了</el-button>
      </div>
      <div class="recommendDialogWrap" v-else>
        <p>预约成功，顾问将在您选择的时间段通过您的登录手机号联系您，请您注意接听。</p>
        <el-button type="primary" @click="appointShow = false">好的</el-button>
      </div>
    </DtPopup>
  </div>
</template>

<script>
import DtPopup from '@/components/layouts/DtPopup';
import DtCopyright from '@/components/layouts/DtCopyright';
import MyConsultant from '@/components/common/MyConsultant';
import Details from './Details';
import Condition from './Condition';
import Introduction from './Introduction';
import Clause from './Clause';
import welfareApi from '@/api/welfare';
import { queryCounselor } from '@/api/firstpage';
import { myMixin } from '@/mixins';
import { isUrl } from "@/utils/utils";

export default {
  name:"planRecommendDetails",
  mixins: [myMixin],
  components: { DtPopup, DtCopyright, MyConsultant, Details, Condition, Introduction, Clause },
  data() {
    return {
      activeTab: '',
      tabOptions: [],
      swiperOptions: {
        grabCursor: true,
        slidesPerView: 'auto',
        width: 'auto',
        freeMode: true,
      },
      recommendDetails: {},
      purchaseNum: 0,
      consultantInfo: {},
      randomRecommendList: [],
      // 预约顾问
      appointShow: false,
      appointInfo: {},
      appointPeriod: '',
      appointPeriodOptions: ['随时', '上午', '下午', '晚上'],
    };
  },
  methods: {
    init() {
      const { welfareId, productType, consultantProductId } = this.$route.query;
      // 线下产品
      if (productType === '1') {
        this.tabOptions = [
          { label: '产品简介', name: 'Introduction' },
          { label: '投保条件', name: 'Condition' },
        ];
        this.activeTab = 'Introduction';
      } else {
        this.tabOptions = [
          { label: '保障详情', name: 'Details' },
          { label: '投保条件', name: 'Condition' },
          { label: '产品简介', name: 'Introduction' },
          { label: '条款资料', name: 'Clause' },
        ];
        this.activeTab = 'Details';
      }
      if (welfareId) {
        welfareApi.WelfareDetail({ productType, consultantProductId }).then(res => {
          if (res) {
            if (res.productType === '1') {
              res.companyLogo = window.atob(res.companyLogo);
            }
            this.recommendDetails = res;
          }
        });
        const enterpriseId = this.$store.state.user.user.enterpriseId;
        // 线上产品
        if (productType === '2') {
          // 多少位同事已投
          welfareApi.GetPurchaseNum({ enterpriseId, welfareId }).then(res => {
            if (res && res.purchaseNum) this.purchaseNum = res.purchaseNum;
          });
        }
        // 猜你喜欢列表
        welfareApi.RandomWelfare({ consultantProductId }).then(res => {
          if (res.length) this.randomRecommendList = res;
        });
        // 是否有专属顾问权限
        if (this.$store.state.allPermission.appGroup4) {
          queryCounselor({ enterpriseId }).then(res => {
            if (res && res.name) this.consultantInfo = res;
          });
        }
      }
    },
    // 立即预约
    async handleAppoint() {
      if (!this.appointInfo.createTime) {
        const res = await welfareApi.Appoint({
          appointPeriod: this.appointPeriod,
          agentCode: this.consultantInfo.code,
          consultantProductId: this.$route.query.consultantProductId,
        });
        this.appointInfo = res;
      }
      this.appointShow = true;
    },
    // 锚点跳转
    handleAnchor(name) {
      this.activeTab = name;
      this.$el.querySelector('#' + name).scrollIntoView();
    },
    // 猜你喜欢
    handleLike({ welfareId, productType, consultantProductId }) {
      this.$router.replace({ name: 'planRecommendDetails', query: { welfareId, productType, consultantProductId } });
      this.init();
    },
    isUrl(url){
      return isUrl(url)
    }
  },
};
</script>

<style lang="less" scoped>
.fc-primary {
  color: var(--primary);
}
.recommendDetails {
  background: #fff;
  .recommendDetailsWrap {
    width: @contentWidth;
    margin: 20px auto 40px;
  }
  .recommendTabs {
    position: sticky;
    z-index: 9;
    top: 0;
    display: flex;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 42px;
    border-bottom: 2px solid var(--primary);
    background-color: #fafafa;
    .recommendTabItem {
      width: 100px;
      height: 42px;
      color: #555;
      cursor: pointer;
      transition: 0.5s;
      text-align: center;
      &.active {
        color: #fff;
        background-color: var(--primary);
      }
      &:hover {
        color: #fff;
        background-color: var(--primary);
      }
    }
    .recommendTabsPS {
      position: absolute;
      top: 0;
      right: 20px;
      color: var(--primary);
    }
  }
  .recommendDetailsContent {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .detailsLeft {
      position: relative;
      flex: 1;
      margin-right: 10px;
      padding: 30px;
      border: 1px solid #dcdce1;
    }
    .detailsRight {
      position: sticky;
      top: 64px;
      width: 230px;
    }
  }
  /deep/ .detailsTitle {
    position: relative;
    padding: 20px 0 20px 8px;
    padding-left: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 3px;
      height: 16px;
      background-color: var(--primary);
      transform: translateY(-50%);
    }
  }
  .detailsHeader {
    .detailsHeaderTitle {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 15px;
      .label {
        width: 70px;
        margin-right: 10px;
        font-size: 14px;
        line-height: 20px;
        color: #fff;
        border-radius: 4px;
        text-align: center;
        &.type1 {
          background: #e27c00 linear-gradient(180deg, #0d7ae2 0%, #7cb3fa 100%);
        }
        &.type2 {
          background: #e27c00 linear-gradient(180deg, #e27d01 0%, #f7b334 99%);
        }
      }
      .title {
        overflow: hidden;
        font-size: 22px;
        font-weight: bold;
        color: #382e2b;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 0;
        flex: 1;
      }
    }
    .detailsHeaderSubTitle {
      margin-bottom: 15px;
      font-size: 18px;
      color: #d3d3d9;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .detailsHeaderLabels {
      margin-bottom: 30px;
      font-size: 16px;
      .swiper-slide {
        width: auto;
        padding: 3px 4px;
        color: #e27c00;
        background: #fcf2e4;
        &:not(:last-of-type) {
          margin-right: 8px;
        }
      }
    }
    .detailsPrice {
      margin-bottom: 20px;
      font-size: 18px;
      color: #333;
      span {
        font-size: 30px;
        font-weight: bold;
        color: #f33;
      }
    }
  }
  .detailsBody {
    font-size: 12px;
    color: #666;
  }
  .detailsFooter {
    margin-top: 30px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
    text-align: center;
  }
  .detailsQrCode {
    margin-bottom: 15px;
    padding: 25px 45px;
    background-color: #fff6e7;
    text-align: center;
    img {
      display: block;
      margin: 0 auto 12px;
    }
    .qrCode {
      width: 140px;
      height: 140px;
    }
    p {
      font-size: 18px;
      color: var(--primary);
    }
  }
  .detailsConsultant {
    margin-bottom: 15px;
    padding: 0 20px 20px;
    background-color: #fafafa;
    .consultantAvatar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 8px 35px 8px 8px;
      font-size: 14px;
      color: #333;
      background-color: #fff;
      .avatar {
        display: block;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background-position: center;
        background-size: cover;
      }
      i {
        font-size: 12px;
        font-weight: bold;
        color: var(--primary);
        border: 1px solid var(--primary);
        border-radius: 50%;
        cursor: pointer;
      }
    }
    .consultantTis {
      margin-bottom: 20px;
      font-size: 12px;
      line-height: 1.5;
      color: #666;
      text-align: justify;
    }
    .consultantLabels {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      span {
        flex: 1;
        line-height: 24px;
        border: 1px solid #dcdce1;
        border-radius: 2px;
        background-color: #f7f8fa;
        cursor: pointer;
        text-align: center;
        &.active {
          color: var(--primary);
          border-color: var(--primary);
          background-color: #fff6e7;
        }
        &:hover {
          color: var(--primary);
          border-color: var(--primary);
          background-color: #fff6e7;
        }
        &:not(:last-of-type) {
          margin-right: 7px;
        }
      }
    }
    .el-button {
      width: 100%;
    }
  }
  .detailsLikes {
    padding: 0 20px 20px;
    background-color: #fafafa;
    .detailsLikesItem {
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #efefef;
    }
    .detailsLikesName {
      margin-bottom: 10px;
      color: #000;
      cursor: pointer;
    }
    .detailsLikesLabel {
      display: flex;
      flex-wrap: wrap;
      span {
        margin-bottom: 5px;
        padding: 3px 6px;
        font-size: 13px;
        color: #999;
        background: #eeeef1;
        &:not(:last-of-type) {
          margin-right: 5px;
        }
      }
    }
  }
  .dt-popup {
    .recommendDialogWrap {
      p {
        line-height: 1.5;
        color: #666;
      }
      .el-button {
        display: block;
        width: 120px;
        margin: 20px auto;
      }
    }
  }
}
.myConsultantInfo {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  .consultant {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .name {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }
    .phone {
      font-size: 15px;
      color: #333;
    }
    .tip {
      font-size: 15px;
      color: #e27c00;
    }
  }
  .qrCode {
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    padding: 4px;
    border: 1px solid #e27c00;
  }
}
</style>
